import { useState, useCallback } from 'react'

export function useSessionStorage<T>(key: string, defaultValue: T): [T, (value: T | ((prev: T) => T)) => void] {
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      const item = sessionStorage.getItem(key)
      return item ? (JSON.parse(item) as T) : defaultValue
    } catch {
      return defaultValue
    }
  })

  const setValue = useCallback(
    (value: T | ((prev: T) => T)) => {
      setStoredValue((prev) => {
        const nextValue = value instanceof Function ? value(prev) : value
        try {
          sessionStorage.setItem(key, JSON.stringify(nextValue))
        } catch {
          // no-op
        }
        return nextValue
      })
    },
    [key]
  )

  return [storedValue, setValue]
}
